import { Form } from 'antd'
import Button from 'components/Button/index'
import RoutePath from 'components/RoutePath'
import LeftArrow from 'components/icons/LeftArrow'
import {
  Div,
  LeftSection,
  RoleNameDiv,
  RoleNameFlex,
  SectionName,
  TopHeader,
} from 'modules/Drives/ViewDrive/Style/style'
import RoleStatus from 'modules/Roles/Partials/RolesTable/RoleStatus/index'
import ViewCollegeDetails from 'modules/Roles/Partials/ViewCollegeDetails/Partials/ViewStudentDrawer'
import JobDetailsDrawer from 'modules/Roles/ViewRole/Header/JobDetailsDrawer'
import ShareDrawer from 'modules/Roles/ViewRole/Header/ShareDrawer'
import {
  PaddedDiv,
  PaddedDivStudent,
  QuestionnaireButton,
  SectionWrapper,
} from 'modules/Roles/ViewRole/Style/style'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { Link, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { FONT } from 'theme/font'
import { roleBasedDegreeListConvertion } from 'utils/roleBasedDegreeListConvertion'
import ConfirmDrawer from './ConfirmDrawer'
import ExStudentTable from './ExStudentTable'
import PreviewDrawer from './PreviewDrawer'
import ShortListDrawer from './ShortListDrawer'

const DrivesButton = styled(Button.Secondary)`
  font-weight: ${FONT.FW_600};
`

const ExStudent = ({
  createShortList,
  getInstitutesList,
  institutesList,
  setInstitutesList,
  degreeListData,
  getDegreesBasedOnRoles,
  getDegreesBasedExRoles,
  driveData,
  getCandidateDetails,
  candidateDetails,
  jobSharingEmail,
  roleBasedDegreeList,
  singleRoleData,
  getAppliedCandidateList,
  appliedCandidatesList,
  getAppliedCandidateListTrue,
  appliedCandidatesListTrue,
  getQuestionaireGraphList,
  graphList,
  getPromotion,
  promotionData,
  getSingleRoleData,
}) => {
  const [corporateId, setCorporateId] = useState('')
  const [citySave, setCitySave] = useState([])
  const cropId = singleRoleData?.corporate?.id

  const [shortListDrawer, setShortListDrawer] = useState(false)
  const [shortListDrawerDetails, setShortListDrawerDetails] = useState({})
  const [applyFilter, setApplyFilter] = useState(false)
  const [studentRating, setStudentRating] = useState('')
  const [degreeDepartment, setDegreeDepartment] = useState('')
  const [degreeDepartmentData, setDegreeDepartmentData] = useState([])
  const [candidateYear, setCandidateYear] = useState('')
  const [noticePeriod, setNoticePeriod] = useState('')
  const [rating, setRating] = useState('')
  const [rolesDegreeList, setRolesDegreeList] = useState([])
  const [detailsDrawer, setDetailsDrawer] = useState(false)
  const [shareDrawer, setShareDrawer] = useState(false)
  const [viewDrawer, setViewDrawer] = useState(false)
  const [newPreviewDrawer, setNewPreviewDrawer] = useState(false)
  const [confirmDrawer, setConfirmDrawer] = useState(false)
  const [candidateRangeMin, setCandidateRangeMin] = useState(0)
  const [candidateRangeMax, setCandidateRangeMax] = useState(0)
  const [selectedRows, setSelectedRows] = useState([])
  const [candidateIds, setCandidateIds] = useState([])
  const [locationStatus, setLocationStatus] = useState()
  const [excandidateId, setExcandidateId] = useState('')
  const [prefferedLocationStatus, setPrefferedLocationStatus] = useState(false)
  const [prefferedLocations, setPrefferedLocations] = useState([])
  const [currentLocationStatus, setCurrentLocationStatus] = useState(false)
  const [shortlistRows, setShortlistRows] = useState(false)
  const [form] = Form.useForm()
  const [jobId, setJobId] = useState([])
  const params = useParams()

  useEffect(() => {
    setJobId(params.jobId)
    setCorporateId(cropId)
  }, [params.jobId, cropId])

  useEffect(() => {
    if (singleRoleData?.length == 0) {
      getSingleRoleData(0,params?.jobId)
    }
  }, [])

  const [errors, setErrors] = useState({
    cityError: '',
    institueError: '',
    filterError: '',
    poolCollegesError: '',
  })
  const handleCreate = async () => {
    if (applyFilter && !studentRating && degreeDepartment == '') {
      setErrors({ ...errors, filterError: 'Minimum one filter required.' })
    }
  }
  const handleShortList = () => {
    setShortListDrawer(true)
  }
  useEffect(() => {
    const updatedData = roleBasedDegreeListConvertion({
      listOfDegree: roleBasedDegreeList,
      parentNameParam: 'degree',
      parentValueParam: 'degreeId',
      pathName: 'streams',
      childrenValueParam: 'degreeStreamMapId',
    })
    setRolesDegreeList(updatedData)
  }, [roleBasedDegreeList])
  useEffect(() => {
    let filterData = {
      rating: studentRating,
      degreeDepartment: degreeDepartment,
    }
    getAppliedCandidateListTrue({
      candidateIds: candidateIds,
      roleId: params?.jobId,
      filterData,
      setShortListDrawerDetails,
      shortListDrawer,
      candidateRangeMin,
      candidateRangeMax,
      prefferedLocationStatus,
      prefferedLocations,
      currentLocationStatus,
      cities: singleRoleData?.cities?.map(item => item.name) || [],
    })
  }, [
    studentRating,
    degreeDepartment,
    shortListDrawer,
    candidateRangeMax,
    candidateRangeMin,
    prefferedLocationStatus,
    currentLocationStatus,
    prefferedLocations,
  ])

  const locationWiseFilterHanlder = value => {
    if (value?.includes('PREFFERED_LOCATION')) {
      setPrefferedLocationStatus(true)
    } else {
      setPrefferedLocationStatus(false)
    }

    if (value?.includes('CURRENT_LOCATION')) {
      setCurrentLocationStatus(true)
    } else {
      setCurrentLocationStatus(false)
    }

    setLocationStatus(value)
  }
  const navigate = useNavigate()

  const OnQuestionnaireClick = () => {
    navigate(`/questionaire-dashboard/${jobId}`)
  }

  useEffect(() => {
    getQuestionaireGraphList({ roleId: params?.jobId, type: 'OVERVIEW' })
  }, [])

  return (
    <>
      <SectionWrapper column>
        <PaddedDiv column>
          <TopHeader row spaceBetween alignCenter>
            <LeftSection centerVertically>
              <Div>
                <Link to={`/roles/${jobId}/view-roleChart`}>
                  <LeftArrow />
                </Link>
              </Div>
              <SectionName column>
                <RoutePath
                  from="View Role "
                  on={'Experienced Candidate'}
                  path={`/roles/${jobId}/view-roleChart`}
                />
                <RoleNameFlex alignCenter>
                  <RoleNameDiv>{singleRoleData?.tittle}</RoleNameDiv>
                  <RoleStatus status={singleRoleData?.status} />
                </RoleNameFlex>
              </SectionName>
            </LeftSection>
            {shortlistRows ? (
              <Button.Primary
                height={'38px'}
                width={'100px'}
                style={{ fontWeight: 'bold' }} // Apply the bold font weight
                text={'Shortlist'}
                onClick={handleShortList}
              />
            ) : null}
          </TopHeader>
        </PaddedDiv>
        <PaddedDivStudent column>
          <TopHeader row spaceBetween alignCenter>
            <RoleNameDiv>{'Experienced Candidate List'}</RoleNameDiv>
            <div style={{ display: 'flex' }}>
              <div>
                {singleRoleData?.questionBankRoleMap?.length > 0 && (
                  <QuestionnaireButton
                    height={'33px'}
                    text={'Questionnaire Overview'}
                    onClick={OnQuestionnaireClick}
                    jobId={jobId}
                    singleRoleData={singleRoleData}
                    pointer={graphList?.length <= 0}
                  />
                )}
              </div>
              <DrivesButton
                height={'33px'}
                weight={'80px'}
                fontWeight={'600'}
                text={'Job Details'}
                onClick={() => {
                  setDetailsDrawer(true)
                }}
              />
            </div>
          </TopHeader>
        </PaddedDivStudent>

        <ExStudentTable
          singleRoleData={singleRoleData}
          appliedCandidatesList={appliedCandidatesList}
          jobId={jobId}
          degreeListData={degreeListData}
          getAppliedCandidateList={getAppliedCandidateList}
          getCandidateDetails={getCandidateDetails}
          candidateDetails={candidateDetails}
          setInstitutesList={setInstitutesList}
          getDegreesBasedOnRoles={getDegreesBasedOnRoles}
          getDegreesBasedExRoles={getDegreesBasedExRoles}
          institutesList={institutesList}
          getInstitutesLis={getInstitutesList}
          driveData={driveData}
          getAppliedCandidateListTrue={getAppliedCandidateListTrue}
          appliedCandidatesListTrue={appliedCandidatesListTrue}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          shortlistRows={shortlistRows}
          setShortlistRows={setShortlistRows}
          rolesDegreeList={rolesDegreeList}
          setCandidateIds={setCandidateIds}
          candidateIds={candidateIds}
          getPromotion={getPromotion}
          promotionData={promotionData}
        />
      </SectionWrapper>

      <ShortListDrawer
        shortListDrawer={shortListDrawer}
        createShortList={createShortList}
        setshortListDrawer={setShortListDrawer}
        setNewPreviewDrawer={setNewPreviewDrawer}
        applyFilter={applyFilter}
        setApplyFilter={setApplyFilter}
        errors={errors}
        candidateRangeMin={candidateRangeMin}
        setCandidateRangeMin={setCandidateRangeMin}
        candidateRangeMax={candidateRangeMax}
        setCandidateRangeMax={setCandidateRangeMax}
        getAppliedCandidateListTrue={getAppliedCandidateListTrue}
        handleCreate={handleCreate}
        setErrors={setErrors}
        form={form}
        count={shortListDrawerDetails}
        appliedCandidatesListTrue={shortListDrawerDetails}
        setNoticePeriod={setNoticePeriod}
        setCandidateYear={setCandidateYear}
        setRating={setRating}
        singleRoleData={singleRoleData}
        studentRating={studentRating}
        degreeDepartment={degreeDepartment}
        setStudentRating={setStudentRating}
        setDegreeDepartment={setDegreeDepartment}
        setDegreeDepartmentData={setDegreeDepartmentData}
        degreeDepartmentData={degreeDepartmentData}
        rolesDegreeList={rolesDegreeList}
        candidateIds={candidateIds}
        setCandidateIds={setCandidateIds}
        setLocationStatus={setLocationStatus}
        locationStatus={locationStatus}
        locationWiseFilterHanlder={locationWiseFilterHanlder}
        prefferedlocationStatus={prefferedLocationStatus}
        setPrefferedLocationStatus={setPrefferedLocationStatus}
        jobId={jobId}
        setPrefferedLocations={setPrefferedLocations}
        prefferedLocations={prefferedLocations}
        setCurrentLocationStatus={setCurrentLocationStatus}
        setShortlistRows={setShortlistRows}
        selectedRows={selectedRows}
        setCitySave={setCitySave}
        citySave={citySave}
      />

      <PreviewDrawer
        newPreviewDrawer={newPreviewDrawer}
        singleRoleData={singleRoleData}
        setNewPreviewDrawer={setNewPreviewDrawer}
        setshortListDrawer={setShortListDrawer}
        setConfirmDrawer={setConfirmDrawer}
        form={form}
        createShortList={createShortList}
        getAppliedCandidateListTrue={getAppliedCandidateListTrue}
        degreeDepartment={degreeDepartment}
        setDegreeDepartmentData={setDegreeDepartmentData}
        degreeDepartmentData={degreeDepartmentData}
        candidateYear={candidateYear}
        noticePeriod={noticePeriod}
        appliedCandidatesListTrue={shortListDrawerDetails}
        rating={rating}
        studentRating={studentRating}
        setNoticePeriod={setNoticePeriod}
        setCandidateYear={setCandidateYear}
        setRating={setRating}
        setCandidateIds={setCandidateIds}
        candidateIds={candidateIds}
        setLocationStatus={setLocationStatus}
        locationStatus={locationStatus}
        setPrefferedLocationStatus={setPrefferedLocationStatus}
        setCurrentLocationStatus={setCurrentLocationStatus}
        currentLocationStatus={currentLocationStatus}
        prefferedlocationStatus={prefferedLocationStatus}
        prefferedLocations={prefferedLocations}
        setPrefferedLocations={setPrefferedLocations}
        candidateRangeMin={candidateRangeMin}
        candidateRangeMax={candidateRangeMax}
        setCandidateRangeMin={setCandidateRangeMin}
        setCandidateRangeMax={setCandidateRangeMax}
        jobId={jobId}
        setShortlistRows={setShortlistRows}
        selectedRows={selectedRows}
        applyFilter={applyFilter}
        setApplyFilter={setApplyFilter}
        citySave={citySave}
        setExcandidateId={setExcandidateId}
        excandidateId={excandidateId}
      />

      <ConfirmDrawer
        setConfirmDrawer={setConfirmDrawer}
        confirmDrawer={confirmDrawer}
        form={form}
        appliedCandidatesListTrue={shortListDrawerDetails}
        singleRoleData={singleRoleData}
        getAppliedCandidateListTrue={getAppliedCandidateListTrue}
        jobId={jobId}
        candidateIds={candidateIds}
        setshortListDrawer={setShortListDrawer}
        setShortlistRows={setShortlistRows}
        selectedRows={selectedRows}
        prefferedlocationStatus={prefferedLocationStatus}
        currentLocationStatus={currentLocationStatus}
        studentRating={studentRating}
        prefferedLocations={prefferedLocations}
        corporateId={corporateId}
        excandidateId={excandidateId}
      />
      <JobDetailsDrawer
        detailsDrawer={detailsDrawer}
        setDetailsDrawer={setDetailsDrawer}
        setShareDrawer={setShareDrawer}
        singleRoleData={singleRoleData}
        corporateId={corporateId}
      />
      <ShareDrawer
        shareDrawer={shareDrawer}
        setShareDrawer={setShareDrawer}
        singleRoleData={singleRoleData}
        corporateId={corporateId}
        jobSharingEmail={jobSharingEmail}
        setDetailsDrawer={setDetailsDrawer}
      />
      <ViewCollegeDetails
        setViewDrawer={setViewDrawer}
        viewDrawer={viewDrawer}
        promotionData={promotionData}
      />
    </>
  )
}

export default ExStudent
